import { render, staticRenderFns } from "./GardenRewardsFilter.vue?vue&type=template&id=6e8ef19f&scoped=true"
import script from "./GardenRewardsFilter.vue?vue&type=script&lang=js"
export * from "./GardenRewardsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ef19f",
  null
  
)

export default component.exports